class HotspotProductCards extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onHotspotClick = this.onHotspotClick.bind(this)
    this.hotspots.forEach(hotspot => {
      this.listeners.add(hotspot, 'click', this.onHotspotClick)
    })

    this.deactivateHotspots = this.deactivateHotspots.bind(this)
    this.productClosers.forEach(productCloser => {
      this.listeners.add(productCloser, 'click', this.deactivateHotspots)
    })
  }

  onHotspotClick (e) {
    this.hotspotsActive = true
    const chosenHotspot = e.currentTarget.dataset.hotspotEl

    this.hotspots.forEach(hotspot => {
      hotspot.setAttribute(
        'aria-current',
        hotspot.dataset.hotspotEl === chosenHotspot,
      )
    })

    this.products.forEach(product => {
      product.setAttribute(
        'aria-hidden',
        product.dataset.productEl !== chosenHotspot,
      )
    })
  }

  deactivateHotspots () {
    this.hotspotsActive = false

    this.hotspots.forEach(hotspot => {
      hotspot.setAttribute('aria-current', false)
    })

    this.products.forEach(product => {
      product.setAttribute('aria-hidden', true)
    })
  }

  // setup options

  get hotspots () {
    return window.BAO.Utils.getElements('[data-hotspot-el]', { context: this })
  }

  get products () {
    return window.BAO.Utils.getElements('[data-product-el]', { context: this })
  }

  get productClosers () {
    return window.BAO.Utils.getElements('[data-hotspot-close-el]', { context: this })
  }

  set hotspotsActive (boolean) {
    this.setAttribute('data-hotspots-active', boolean)
  }

  get hotspotsActive () {
    return this.dataset?.hotspotsActive === 'true'
  }
}

const elementName = 'hotspot-product-cards'
if (!customElements.get(elementName)) {
  customElements.define(elementName, HotspotProductCards)
}
